<script setup>
import { computed } from 'vue';
import Checkbox from 'dashboard/components-next/checkbox/Checkbox.vue';

const props = defineProps({
  isChecked: {
    type: Boolean,
    default: false,
  },
  value: {
    type: String,
    default: null,
  },
});

const emit = defineEmits(['update']);

// UI-FILTROS-01 (G13): a caixa do perfil desenha o Checkbox padrão, com a mesma API. O id que o
// pai passa cai no Checkbox e chega ao <input> (G12), por cima do id do value, como antes.
const checked = computed({
  get: () => props.isChecked,
  set: value => emit('update', props.value, value),
});
</script>

<template>
  <Checkbox
    :id="value"
    v-model="checked"
    :value="value"
    class="mt-0.5 shrink-0"
  />
</template>
